import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="workers--worker"
export default class extends Controller {
  static targets = [
    "table",
    "form",
    "tab",
    "pane"
  ]

  connect() {
    this.updateBreadcrumb();
  }

  edit(event) {
    const badge = this.tableTarget.querySelector('tr span.badge');
    const row = event.currentTarget.closest('tr');
    const secondCell = row.children[1];

    if (badge && secondCell) {
      secondCell.append(badge);
    }
  }

  updateBreadcrumb() {
    const name = this.formTarget.querySelector(`input[name$="[name]"]`).value;

    document.querySelector(".master-page .crumb").innerHTML = `マスタ ＞ 職員マスタ ＞ ${name}`;
  }

  switchTab(event) {
    const selected = event.currentTarget.dataset.tab

    this.tabTargets.forEach(tab => {
      tab.classList.toggle("active", tab.dataset.tab === selected)
    })

    this.paneTargets.forEach(pane => {
      pane.style.display = pane.dataset.pane === selected ? "block" : "none"
    })
  }

  cloneEntry(event) {
    const entry = event.currentTarget;
    const { type, id } = entry.dataset;

    let cloneButtonId = "";

    if (type === "PersonalWage") {
      cloneButtonId = "personal-wage-clone-btn";
    } else if (type === "PersonalWorkTypeWage") {
      cloneButtonId = "personal-work-type-wage-clone-btn";
    }

    const link = document.getElementById(cloneButtonId);

    if (!!link) {
      link.href = link.dataset.defaultUrl.replace("DEFAULT", id);

      const container = entry.closest("[data-pane]");
      const badge     = container.querySelector("tbody .badge");

      const currentBadgeTd   = badge.closest("td");
      const currentBadgeTr   = currentBadgeTd.closest("tr");
      const badgeColumnIndex = Array.from(currentBadgeTr.cells).indexOf(currentBadgeTd);;

      entry.cells[badgeColumnIndex].prepend(badge);
    }
  }
}
